import React from 'react';
import Icon from '../../../components/AppIcon';

const CredentialSummaryWidget = () => {
  const summaryData = {
    totalCredentials: 24,
    activeCredentials: 22,
    pendingVerifications: 3,
    recentActivity: 8,
    walletHealth: 95,
    blockchainSync: 100,
    privacyScore: 88
  };

  const progressItems = [
    {
      label: 'Wallet Health',
      value: summaryData?.walletHealth,
      color: 'bg-success',
      icon: 'Shield'
    },
    {
      label: 'Blockchain Sync',
      value: summaryData?.blockchainSync,
      color: 'bg-primary',
      icon: 'Link'
    },
    {
      label: 'Privacy Score',
      value: summaryData?.privacyScore,
      color: 'bg-accent',
      icon: 'Eye'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-foreground">Credential Overview</h2>
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-success rounded-full"></div>
          <span className="text-sm text-muted-foreground">All systems operational</span>
        </div>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <div className="text-center">
          <div className="text-2xl font-bold text-foreground">{summaryData?.totalCredentials}</div>
          <div className="text-sm text-muted-foreground">Total Credentials</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-success">{summaryData?.activeCredentials}</div>
          <div className="text-sm text-muted-foreground">Active</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-warning">{summaryData?.pendingVerifications}</div>
          <div className="text-sm text-muted-foreground">Pending</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-primary">{summaryData?.recentActivity}</div>
          <div className="text-sm text-muted-foreground">Recent Activity</div>
        </div>
      </div>
      <div className="space-y-4">
        {progressItems?.map((item, index) => (
          <div key={index} className="flex items-center space-x-4">
            <div className="flex items-center space-x-2 w-32">
              <Icon name={item?.icon} size={16} className="text-muted-foreground" />
              <span className="text-sm text-foreground">{item?.label}</span>
            </div>
            <div className="flex-1 bg-muted rounded-full h-2">
              <div 
                className={`${item?.color} h-2 rounded-full transition-all duration-300`}
                style={{ width: `${item?.value}%` }}
              ></div>
            </div>
            <span className="text-sm font-medium text-foreground w-12 text-right">{item?.value}%</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CredentialSummaryWidget;